module.exports = function anonymous(it
) {
var out='<div class="list-log-history"> <ul class="history-items"></div>';return out;
}